const MODULE_ID = 'elearning'; // used as vuex store module id
export default MODULE_ID;
